module.exports = __webpack_public_path__ + "img/ch21.fb408d27.jpg";